module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDQwIDQwIj48cGF0aCBkPSJNOSAzaDE2LjVMMzQgMTEuNVYzNWEyIDIgMCAwIDEtMiAySDlhMiAyIDAgMCAxLTItMlY1YTIgMiAwIDAgMSAyLTJ6IiBmaWxsPSIjNUM3Q0ZBIi8+PHBhdGggZD0iTTI1LjUgM3Y2LjVhMiAyIDAgMCAwIDIgMkgzNHoiIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iLjQ1Ii8+PHBhdGggZD0iTTEzIDE5aDE1djJIMTN6TTEzIDIzLjVoMTV2MkgxM3pNMTMgMjhoMTB2MkgxM3oiIGZpbGw9IiNmZmYiLz48L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/disk/text.svg
// module id = 1305
// module chunks = 8